import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface TopoDoPerfilProps {
  /** Rótulo do ciclo escolhido no seletor (ex.: "2S2026"). */
  cicloLabel?: string;
  /** O seletor de ciclo: o `TabTitle` da página, que também sincroniza o ciclo global. */
  seletor: ReactNode;
}

export default function TopoDoPerfil({ cicloLabel, seletor }: TopoDoPerfilProps) {
  return (
    <>
      <div className="flex items-center gap-3.5">
        <Link
          to="/"
          aria-label="Voltar"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue text-brand-yellow hover:text-brand-yellow"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </Link>
        <h1 className="m-0 font-display text-[28px] font-extrabold text-brand-blue-dark">Meu perfil</h1>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-5">
        <p className="m-0 flex flex-wrap items-baseline gap-3 font-display text-[22px] font-bold">
          <span className="text-brand-blue-dark">Seu histórico Joga Junto BB</span>
          {cicloLabel && (
            <>
              <span aria-hidden="true" className="text-[color:var(--border-default)]">
                |
              </span>
              <span className="text-brand-blue">Ciclo {cicloLabel}</span>
            </>
          )}
        </p>
        {seletor}
      </div>
    </>
  );
}
